import {
  BookmarkIcon,
  HamburgerMenuIcon,
  PersonIcon,
} from '@radix-ui/react-icons';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonCallout } from 'components/common/callouts';
import { BaseballIcon } from 'components/common/custom-icon/shorthands';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonFormGrid } from 'components/common/form/grid';
import { SubSectionBox } from 'components/sections/feature-demo/sub-section-box';
import { RADIX, RadixCalloutSize, RadixColor } from 'lib_ts/enums/radix-ui';

const lorem =
  'Ad pariatur occaecat proident cillum sit cillum tempor laboris quis ullamco cupidatat.';

const COLORS: RadixColor[] = [
  RADIX.COLOR.SUCCESS,
  RADIX.COLOR.WARNING,
  RADIX.COLOR.DANGER,
  RADIX.COLOR.NEUTRAL,
  RADIX.COLOR.ACCENT,
];

const SIZES: RadixCalloutSize[] = ['1', '2', '3'];

export const CalloutsDemo = () => (
  <ErrorBoundary identifier="CalloutsDemo">
    <SubSectionBox title="Callouts" source="common/callouts">
      <CommonFormGrid columns={2}>
        {/* without icon */}
        {COLORS.map((color, index) => (
          <CommonCallout
            key={index}
            text={color.toUpperCase() + ' as text without icon... ' + lorem}
            color={color}
            hideIcon
          />
        ))}
        {/* with header */}
        {COLORS.map((color, index) => (
          <CommonCallout
            key={index}
            icon={<PersonIcon />}
            header="With Header"
            text={color.toUpperCase() + ' as text with header... ' + lorem}
            color={color}
          />
        ))}
        {/* without header */}
        {COLORS.map((color, index) => (
          <CommonCallout
            key={index}
            icon={<BookmarkIcon />}
            text={color.toUpperCase() + ' as text without header... ' + lorem}
            color={color}
          />
        ))}
        {/* with timeout */}
        {COLORS.map((color, index) => (
          <CommonCallout
            key={index}
            icon={<BookmarkIcon />}
            text={
              color.toUpperCase() + ' as text with auto-dismiss... ' + lorem
            }
            color={color}
            autoDismissMS={5_000}
          />
        ))}
        {/* with actions */}
        {COLORS.map((color, index) => (
          <CommonCallout
            key={index}
            icon={<HamburgerMenuIcon />}
            text={color.toUpperCase() + ' as text with actions... ' + lorem}
            color={color}
            actions={[
              {
                label: 'Action 1',
                color: color,
                onClick: () => {
                  NotifyHelper.info({ message_md: `Action clicked!` });
                },
              },
              {
                label: 'Action 2',
                color: color,
                onClick: () => {
                  NotifyHelper.info({ message_md: `Action clicked!` });
                },
              },
            ]}
          />
        ))}

        {SIZES.map((size, index) => (
          <CommonCallout
            key={index}
            icon={<BaseballIcon />}
            size={size}
            text={`Size ${size.toUpperCase()} as text with icon... ${lorem}`}
          />
        ))}
      </CommonFormGrid>
    </SubSectionBox>
  </ErrorBoundary>
);
